import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["session"];
var _span, _span2, _span3, _span4, _PopperTrigger;
import { useState } from 'react';
import Calendar from '@crehana/compass.icons.outline/Calendar';
import Link from '@crehana/compass.icons.outline/Link';
import MoreVertical from '@crehana/compass.icons.outline/MoreVertical';
import Pin from '@crehana/compass.icons.outline/Pin';
import { cn, Dialog, DialogTrigger, Popper, PopperContent, PopperTrigger, Tag } from '@crehana/compass.ui/v2';
import { CustomNextImage } from '@crehana/next';
import { TimeZonesEnum } from '@crehana/ts-types';
import { SessionTypeEnum } from "../../graphql/types/globals.v5";
import { useLiveSessionsTranslation } from "../../hooks/useLiveSessionsTranslation";
import { formatDateAndDuration } from "../../utils/formatDateAndDuration";
import { getLiveSessionImagePlaceholder } from "../../utils/getSessionImagePlaceholder";
import { DeleteSessionModal } from "./DeleteSessionModal";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var DateTimeAndGuests = function DateTimeAndGuests(_ref) {
  var session = _ref.session;
  var _useLiveSessionsTrans = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans.t,
    languageCode = _useLiveSessionsTrans.languageCode;
  return /*#__PURE__*/_jsxs("p", {
    className: "tw-font-body4 tw-text-neutral-light-700 tw-flex tw-items-center tw-line-clamp-1 dark:tw-text-neutral-dark-300",
    children: [_span || (_span = /*#__PURE__*/_jsx("span", {
      className: "tw-h-2.4 tw-w-2.4 tw-flex tw-items-center tw-justify-center tw-mr-0.8 tw-shrink-0",
      children: /*#__PURE__*/_jsx(Calendar, {
        className: "tw-text-inherit",
        size: 16
      })
    })), /*#__PURE__*/_jsxs("span", {
      className: "tw-line-clamp-1",
      children: [formatDateAndDuration(session.startDate, session.endDate, TimeZonesEnum[session.timeZone], languageCode), session.guestsCount > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [_span2 || (_span2 = /*#__PURE__*/_jsx("span", {
          className: "tw-hidden md:tw-inline-block tw-text-inherit tw-mx-0.8",
          children: '|'
        })), /*#__PURE__*/_jsx("span", {
          className: "tw-hidden md:tw-inline-block",
          children: t('DATE_SESSIONS_CARD_GUESTS', {
            interpolation: {
              guests: session.guestsCount
            }
          })
        })]
      })]
    })]
  });
};
var SessionAddressOrLink = function SessionAddressOrLink(_ref2) {
  var session = _ref2.session;
  var _useLiveSessionsTrans2 = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans2.t;
  return /*#__PURE__*/_jsx("div", {
    className: "tw-font-body4 tw-flex tw-items-center tw-text-neutral-light-700 dark:tw-text-neutral-dark-300",
    children: session.eventType === SessionTypeEnum.ONLINE ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [_span3 || (_span3 = /*#__PURE__*/_jsx("span", {
        className: "tw-h-2.4 tw-w-2.4 tw-flex tw-items-center tw-justify-center tw-mr-0.8 tw-shrink-0",
        children: /*#__PURE__*/_jsx(Link, {
          className: "-tw-rotate-45 tw-text-inherit",
          size: 16
        })
      })), /*#__PURE__*/_jsx("div", {
        className: "tw-line-clamp-1",
        children: t('SESSION_CARD_LINK_PLACEHOLDER')
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [_span4 || (_span4 = /*#__PURE__*/_jsx("span", {
        className: "tw-h-2.4 tw-w-2.4 tw-flex tw-items-center tw-justify-center tw-mr-0.8 tw-shrink-0",
        children: /*#__PURE__*/_jsx(Pin, {
          className: "tw-text-inherit",
          size: 16
        })
      })), /*#__PURE__*/_jsx("div", {
        className: "tw-line-clamp-1",
        children: session.location
      })]
    })
  });
};
var AdminActionButtons = function AdminActionButtons(_ref3) {
  var session = _ref3.session,
    organizationSlug = _ref3.organizationSlug,
    onDeleteSessionClick = _ref3.onDeleteSessionClick;
  var _useLiveSessionsTrans3 = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans3.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openDialog = _useState2[0],
    setOpenDialog = _useState2[1];
  var handleSessionDelete = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return onDeleteSessionClick(session.id);
          case 2:
            setOpenDialog(false);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSessionDelete() {
      return _ref4.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_jsxs(Dialog, {
    open: openDialog,
    onOpenChange: setOpenDialog,
    children: [/*#__PURE__*/_jsxs(Popper, {
      children: [_PopperTrigger || (_PopperTrigger = /*#__PURE__*/_jsx(PopperTrigger, {
        asChild: true,
        children: /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "tw-shrink-0",
          children: /*#__PURE__*/_jsx(MoreVertical, {
            className: "dark:tw-text-neutral-light-100",
            size: 24
          })
        })
      })), /*#__PURE__*/_jsx(PopperContent, {
        className: "tw-overflow-hidden",
        removePadding: true,
        align: "start",
        side: "left",
        children: /*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-flex-col tw-items-start",
          children: [/*#__PURE__*/_jsx("a", {
            href: "/org/".concat(organizationSlug, "/panel/content/lives/").concat(session.id, "/"),
            className: cn('tw-px-2.4 tw-py-1.2 tw-font-body4 tw-h-4.8 tw-w-[190px] tw-text-left tw-transition-colors disabled:tw-opacity-40', 'hover:tw-text-primary-light-500 dark:hover:tw-bg-elevation-dark-03 dark:hover:tw-text-secondary-light-500 hover:tw-bg-neutral-light-300'),
            children: t('SESSION_CARD_CTA_DETAIL')
          }), /*#__PURE__*/_jsx("a", {
            href: "/org/".concat(organizationSlug, "/panel/content/lives/").concat(session.id, "/edit/?from=lives-list"),
            className: cn('tw-px-2.4 tw-py-1.2 tw-font-body4 tw-h-4.8 tw-w-[190px] tw-text-left tw-transition-colors disabled:tw-opacity-40', 'hover:tw-text-primary-light-500 dark:hover:tw-bg-elevation-dark-03 dark:hover:tw-text-secondary-light-500 hover:tw-bg-neutral-light-300'),
            children: t('SESSION_CARD_CTA_EDIT')
          }), /*#__PURE__*/_jsx(DialogTrigger, {
            asChild: true,
            children: /*#__PURE__*/_jsx("button", {
              className: cn('tw-px-2.4 tw-py-1.2 tw-font-body4 tw-h-4.8 tw-w-[190px] tw-text-left tw-transition-colors disabled:tw-opacity-40', 'hover:tw-text-primary-light-500 dark:hover:tw-bg-elevation-dark-03 dark:hover:tw-text-secondary-light-500 hover:tw-bg-neutral-light-300'),
              type: "button",
              children: t('SESSION_CARD_CTA_DELETE')
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(DeleteSessionModal, {
      sessionTitle: session.title,
      onDelete: handleSessionDelete
    })]
  });
};
export var NewLiveSessionCard = function NewLiveSessionCard(_ref5) {
  var session = _ref5.session,
    otherProps = _objectWithoutProperties(_ref5, _excluded);
  var _useLiveSessionsTrans4 = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans4.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-p-1.6 tw-flex tw-flex-col tw-items-end tw-gap-1.6 md:tw-items-center md:tw-flex-row tw-relative tw-bg-neutral-light-100 tw-rounded dark:tw-bg-elevation-dark-02",
    children: [/*#__PURE__*/_jsx("div", {
      className: "tw-relative tw-overflow-hidden tw-shrink-0 tw-w-full tw-h-16 md:tw-h-[90px] md:tw-w-[140px]",
      children: /*#__PURE__*/_jsx(CustomNextImage, {
        className: "tw-rounded tw-object-cover",
        src: getLiveSessionImagePlaceholder({
          eventType: session.eventType,
          imageUrl: session.imageUrl
        }),
        layout: "fill",
        objectFit: "cover"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-grow tw-space-y-0.8 tw-w-full tw-flex tw-items-center tw-justify-between md:tw-h-[90px]",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "tw-h-full tw-flex tw-flex-col tw-justify-between",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "tw-font-subtitle3 tw-text-neutral-light-800 dark:tw-text-neutral-light-100",
          children: session.title
        }), /*#__PURE__*/_jsx(SessionAddressOrLink, {
          session: session
        }), /*#__PURE__*/_jsx(DateTimeAndGuests, {
          session: session
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-flex-col tw-justify-between tw-h-full tw-items-end",
        children: [/*#__PURE__*/_jsx("div", {
          className: "tw-absolute tw-top-2.4 tw-right-2.4 md:tw-relative md:tw-top-0 md:tw-right-0",
          children: /*#__PURE__*/_jsx(Tag, {
            className: "tw-absolute tw-top-0 tw-right-0 tw-font-label1 tw-w-max",
            children: t('NEW_LIVE_SESSION_TAG')
          })
        }), /*#__PURE__*/_jsx(AdminActionButtons, _objectSpread({
          session: session
        }, otherProps))]
      })]
    })]
  });
};